import { FulfillmentOrderAddressSchema } from "@redotech/redo-fulfillment-customs-common/fulfillment-order-address";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getFulfillmentGroupAddress = {
  name: "getFulfillmentGroupAddress" as const,
  input: z.object({ fulfillmentGroupId: zExt.objectId() }),
  output: z.object({
    address: FulfillmentOrderAddressSchema.nullish(),
    verified: z.boolean().nullish(),
  }),
};
